import moment from 'moment-timezone';
import type { CancellationAndNoShowsReport } from 'model/CancellationAndNoShowsReport';

export enum CancellationAndNoShowsReportStatus {
    Initial = 'Initial',
    Getting = 'Getting',
    GettingSuccess = 'GettingSuccess',
    Error = 'Error'
}

export const emptyCancellationAndNoShowsReport: CancellationAndNoShowsReport = {
    start: moment.invalid(),
    end: moment.invalid(),
    rebookWindowDays: 30,
    rows: []
};

export interface CancellationAndNoShowsReportState {
    report: CancellationAndNoShowsReport;
    status: CancellationAndNoShowsReportStatus;
    loading: boolean;
}
